
























import { ChevronDownIcon } from 'tdesign-icons-vue';
import { defineComponent, getCurrentInstance, onUnmounted, ref } from '@vue/composition-api/dist/vue-composition-api';
import { Location } from 'vue-router';
import i18n, { i18n_t } from '@/locales/i18n';
import smh from '@/renderer/scripts/smh';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import tips from '@/renderer/scripts/utils/tips';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import store from '@/renderer/store';
import EsignDialog from './EsignDialog/index.vue';
export default defineComponent({
  name: 'ElectronSign',
  components: {
    ChevronDownIcon,
    EsignDialog,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const electronSignAvailable = ref(false); // 是否展示电子签入口
    const showEsign = ref(false);
    const wpsResult = ref(null);
    const isOpenESignDialog = ref(false); // 是否手动打开电子签

    const methods = {
      initData() {
        const { $route } = vm;
        const { esign = '' } = $route.query;
        const filename = $route.query.name as string;
        if (!filename) return;
        const ext = filename.slice(filename.lastIndexOf('.') + 1);
        if (!['pdf'].includes(ext.toLowerCase())) {
          electronSignAvailable.value = true;
        }
        // 若传递了sign标记，则需要自动弹出电子签
        if (+esign === 1) {
          methods.openEsignDialog();
          const routeQuery = {
            ...$route.query,
          };
          delete routeQuery.esign;
          dispatchRouter({
            ...$route,
            query: routeQuery,
          } as Location);
        }
      },
      async openEsignDialog() {
        const { $route } = vm;
        const { name: filename, path, spaceOrgId = vm.$store.getters.orgId, spaceId } = $route.query;
        try {
          const { data } = await smh.userAPI.getDirectoryOrFileInfo({
            path: [path, filename].filter(v => v).join('/'),
            spaceId: spaceId as string,
            spaceOrgId: Number(spaceOrgId),
          });
          if (+data.size > ConstantConfig.esignFileMaxSize) {
            tips.error(i18n_t('只支持 60 MB 以内的文件发起电子签'));
            return;
          }
        } catch (error) {
          // 出错则不判断文件大小，直接允许发起电子签
        }
        if ($route.name === 'edit') {
          // 若是编辑文档页面，则需要先保存再打开电子签
          isOpenESignDialog.value = true;
          const previewObject = document.getElementById('preview-object') as HTMLIFrameElement;
          previewObject?.contentWindow?.postMessage(
            {
              smhAction: 'smhSaveDocCmd',
            },
            '*',
          );
          tips.loading(i18n_t('正在保存文件'));
        } else {
          showEsign.value = true;
        }
      },
      // 点击头部按钮事件
      async onOperateEventProxy(command: string) {
        switch (command) {
          case 'startSignFlow':
            methods.openEsignDialog();
            break;
          default:
            break;
        }
      },
      handleOfficeMessage(event: MessageEvent) {
        if (event.data?.smhAction === 'wpsSaved' && isOpenESignDialog.value) {
          setTimeout(() => {
            tips.closeAll();
            isOpenESignDialog.value = false;
            showEsign.value = true;
            wpsResult.value = event.data.result;
          }, 1000);
        }
      },
    };
    methods.initData();
    window.addEventListener('message', methods.handleOfficeMessage);
    onUnmounted(() => {
      window.removeEventListener('message', methods.handleOfficeMessage);
    });
    return {
      showEsign,
      wpsResult,
      electronSignAvailable,
      ...methods,
    };
  },
});
